import React, { useState, useEffect } from "react";

const FRMTopbar = () => {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const utc = time.toUTCString().slice(17, 22);
  const day = time.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });

  return (
    <div className="frm-topbar">
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div className="frm-logo-box">PRPM</div>
        <div>
          <div className="frm-brand-name">Plant Risk & Performance Management</div>
          {/* <div className="frm-brand-sub">Marine Edge Device Management System</div> */}
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.75)" strokeWidth="2">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <div>
          <div className="frm-time-val">{utc} UTC</div>
          <div className="frm-time-sub">{day}</div>
        </div>
      </div>
    </div>
  );
};
export default FRMTopbar;